import { useTheme } from '@mui/material/styles';

export const ComparisonStyles = () => {
    const theme = useTheme();
    return {
        "& .comparison-card": {
            backgroundColor: theme.palette.primary.contrastText,
            boxShadow: "0 0px 4px #c5c5c5",
            height: '100%',
            margin: {
              xs: "0 0 14px 0",
              md: 0
            },
            position: "relative",
            "& .label": {
                fontSize: "12px",
                height: "24px",
                display: 'block',
                fontWeight: 'bold',
                marginBottom: '10px',
            },
            "& .comparison-card__title": {
                background: theme.palette.primary.dark,
                color: theme.palette.primary.contrastText,
                fontSize: "16px",
                margin: 0,
                padding: "11px",
                textAlign: {
                    xs: "center",
                    lg: "left"
                },
            },
            "& .comparison-card__timeline": {
                "& button": {
                    background: theme.palette.primary.dark,
                    color: theme.palette.primary.contrastText,
                    fontSize: "11px",
                    fontWeight: "bold",
                    display: "flex",
                    margin: "6px auto 10px",

                    "&:hover, &:focus":
                    {
                        background: theme.palette.primary.light,
                        color: theme.palette.primary.contrastText,
                        textDecoration: "none"
                    },

                    "& img": {
                        backgroundColor: theme.palette.primary.contrastText,
                        borderRadius: "50%",
                        marginLeft: "4px",
                        transition: ".2s linear",
                        width: "28px"
                    },
                },
            },
            "& .comparison-card__form-select": {
                flex: 1,
                "& label": {
                    display: "none",
                },
            },
            "& .comparison-card__data": {
                padding: "10px",
            },
            "& .comparison-card__subtitle": {
                borderTop: " 2px solid #f7f7f7",
                display: "flex",
                fontSize: "14px",
                padding: "10px 10px 0",
            },
            "& .comparison-card__amount": {
                borderRight: {
                    lg: "1px dotted #d4d4d4"
                }
            },
            "& .comparison-card__amount, .comparison-card__group-amount": {
                fontSize: {
                    sm: "28px",
                    lg: "22px"
                },
                textAlign: "center",
                padding: "10px 4px",
                display: {
                    lg: "inline-block"
                },
                width: {
                    lg: "50%",
                }
            },
            "& .comparison-card__average": {
                fontSize: "14px",
                color: "#343A40",
                textAlign: "justify",
                padding: "0 0 10px",
                minHeight: "42px",
            },
            "& .average-value": {
                fontWeight: "bold",

                "&.positive": {
                    color: "#00b050",
                },

                "&.negative": {
                    color: "red",
                },
            },

            ".ranking-group-collapse": {
                background: "#E1D7F0",
                borderRadius: 0,
                border: 0,
                padding: {
                    sm: "6px 10px !important",
                    lg: "12px 10px !important",
                },
                fontSize: "12px",
                textAlign: "center",
                width: {
                    xs: "100%",
                    lg: "auto"
                },
                position: {
                    lg: "absolute",
                },
                top: {
                    lg: 0
                },
                right: {
                    lg: 0
                },
                "&:hover": {
                    background: "#AF96DC",
                },
                "& .value": {
                    fontWeight: "bold"
                },
            },
            "& .comparison-card__toggle-icon": {
                margin: "-2px 4px 0 0",
            },
            "& .comparison-card__toggle-icon.hide": {
                transform: "rotate(180deg)",
            },
            "& .comparison-card__ranking-table": {
                fontSize: "14px",
                marginBottom: 0,
                "& thead th": {
                    fontWeight: "bold",
                },

                "& .row--highlighted": {
                    background: "#E1D7F0",
                },
            },
            "& .comparison-card--no-data": {
                background: "#f1f1f1",
                display: "flex",
                flexDirection: "column",
                height: "calc(100% - 130px)",
                margin: "20px auto",
                width: "90%",
                justifyContent: "center",
                alignItems: "center",
                fontWeight: "bold",
                fontSize: " .8rem",
                minHeight: "100px",

                "& p": {
                    marginHottom: 0,
                }
            },

            "& .timeline__chart": {
                borderTop: "2px solid #f7f7f7",
                paddingTop: "10px",
            },

            "& .comparison-select label": {
                fontSize: "12px",
                marginBottom: 0,
                textTransform: "capitalize",
            },

            "& .help-tooltip": {
                color: theme.palette.grape.main,
                display: "flex",
                float: "left",
                textAlign: "center",
                borderRadius: "50%",
                fontWeight: "bold",
                fontSize: "16px",
                justifyContent: "center",
                alignItems: "center",
                margin: "-1px 4px 0 0",
                opacity: ".7",
                cursor: "default"
            },
        },
    }
}
